import getColour from '@lendi-ui/commons/colours';

import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { SummaryStringDisplay, TextAreaField } from '../../Fields';
import { EditableViewProps, StringReadOnlyViewProps } from '../types';

interface IncomeCommentEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  label?: string;
  name?: string;
  piiStringInLabel?: string;
}

export function IncomeCommentEditableView(props: IncomeCommentEditableViewProps) {
  const { label, incomeIndex, isOptional, isDisabled, name, piiStringInLabel } = props;

  return (
    <TextAreaField
      name={name || FIELD_PATHS.INCOME_COMMENTS(incomeIndex)}
      label={label}
      piiStringInLabel={piiStringInLabel}
      validationFailMessage={'Please fill the comment'}
      isOptional={isOptional}
      isDisabled={isDisabled}
      isFullWidth
    />
  );
}

interface IncomeCommentReadOnlyViewProps extends StringReadOnlyViewProps {}

export function IncomeCommentReadOnlyView(props: IncomeCommentReadOnlyViewProps) {
  const { title, value, piiStringInTitle } = props;
  return (
    <SummaryStringDisplay
      data-component="teamview-income-comments-readonly-content"
      title={title}
      piiStringInTitle={piiStringInTitle}
      value={value}
      textColor={getColour('text', 'main')}
      headingSize={'xs'}
    />
  );
}
